import React, { useState } from 'react';

const TestTabs = () => {
  const [activeTab, setActiveTab] = useState('pending');
  console.log('TestTabs activeTab:', activeTab);

  return (
    <div className="space-y-6">
      <h1>Test Tabs Component</h1>
      
      {/* Simple Tabs */}
      <div className="card">
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => {
              console.log('Clicking pending');
              setActiveTab('pending');
            }}
            className={`px-6 py-3 font-medium text-sm ${
              activeTab === 'pending'
                ? 'border-b-2 border-blue-500 text-blue-600 bg-blue-50'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Tab 1 - Pending
          </button>
          <button
            onClick={() => {
              console.log('Clicking paid');
              setActiveTab('paid');
            }}
            className={`px-6 py-3 font-medium text-sm ${
              activeTab === 'paid'
                ? 'border-b-2 border-green-500 text-green-600 bg-green-50'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Tab 2 - Paid
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'pending' && (
        <div className="card">
          <h2>Pending Content</h2>
          <p>This is the pending tab content.</p>
        </div>
      )}

      {activeTab === 'paid' && (
        <div className="card">
          <h2>Paid Content</h2>
          <p>This is the paid tab content.</p>
        </div>
      )}
    </div>
  );
};

export default TestTabs;